import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { transformDateFormat } from 'susy-common/date-utils';
import { ExtensionRequestActionType } from '../actionTypes/extensionRequest';
import { PostDispatch, ExtensionRequest } from '../types';

export const createExtensionRequest =
    (extensionRequest: ExtensionRequest, files: Array<File> | null) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const formData = new FormData();
        if (!files || files.length === 0) {
            return;
        }

        for (const file of files) {
            formData.append(`extensionRequest_fileOfProof[]`, file);
        }

        formData.append('extensionRequest', JSON.stringify(extensionRequest));
        const response = await SuSyApi.post(`/extensionRequest`, formData);

        dispatch({
            type: ExtensionRequestActionType.SAVE_EXTENSION_REQUEST,
            payload: transformDateFormat(response.data),
        });
    };

export const acceptExtensionRequest =
    (extensionRequest: ExtensionRequest) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.patch(
            `/extensionRequest/accept`,
            extensionRequest
        );
        dispatch({
            type: ExtensionRequestActionType.RESPOND_TO_EXTENSION_REQUEST,
            payload: transformDateFormat(response.data),
        });
    };

export const declineExtensionRequest =
    (extensionRequest: ExtensionRequest) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.patch(
            `/extensionRequest/decline`,
            extensionRequest
        );
        dispatch({
            type: ExtensionRequestActionType.RESPOND_TO_EXTENSION_REQUEST,
            payload: transformDateFormat(response.data),
        });
    };

export const confirmAnsweredExtensionRequest =
    (extensionRequests: ExtensionRequest[]) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.patch(`/extensionRequest/confirm`, {
            extensionRequests,
        });
        dispatch({
            type: ExtensionRequestActionType.CONFIRM_ANSWERED_EXTENSION_REQUEST,
            payload: transformDateFormat(response.data),
        });
    };

export const getSupervisorExtensionById =
    (id: string | null) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(
            `/extensionRequest/project/supervisor/${id}`
        );
        dispatch({
            type: ExtensionRequestActionType.GET_EXTENSION_REQUEST_BY_ID,
            payload: transformDateFormat(response.data),
        });
    };

export const getAdminExtensionById =
    (id: string | null) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(
            `/extensionRequest/project/admin/${id}`
        );
        dispatch({
            type: ExtensionRequestActionType.GET_EXTENSION_REQUEST_BY_ID,
            payload: transformDateFormat(response.data),
        });
    };

